import { graphqlOperation } from 'aws-amplify';
import {
  bulkDeleteStore as bulkDeleteStoreMutation,
  createStore as createStoreMutation,
  deleteStore as deleteStoreMutation,
  updateStore as updateStoreMutation,
} from '../../graphql/mutations';
import { fetchStoresQuery } from '../../layouts/stores/queries';
import { graphql } from '../../utils/api';

const storesStore = {
  state: {
    stores: [],
    selectedStoreId: null,
  },

  reducers: {
    SET_STORES(state, payload) {
      return {
        ...state,
        stores: payload,
      };
    },
    SELECT_STORE(state, payload) {
      return {
        ...state,
        selectedStoreId: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async fetchStores() {
      const stores = await fetchStoresQuery();
      dispatch.stores.SET_STORES(stores?.data?.listStores?.items || []);
    },

    setStores(payload) {
      dispatch.stores.SET_STORES(payload);
    },

    async createStore(payload, rootState) {
      const merchantAccountId = rootState.auth?.user?.merchantAccount?.id;
      const mutationInput = {
        ...payload.values,
        storeStatus: 'NEW',
        merchantAccountId,
      };
      const addRes = await graphql(
        graphqlOperation(createStoreMutation, {
          input: mutationInput,
        }),
      );
      this.fetchStores();
      return addRes;
    },

    async deleteStore(payload, rootState) {
      const { id } = payload;
      await graphql(
        graphqlOperation(deleteStoreMutation, {
          input: { id },
        }),
      );
      const newStores = [];
      rootState.stores.stores.map((storeItem) => {
        if (storeItem.id !== id) {
          newStores.push(storeItem);
        }
      });
      dispatch.stores.SET_STORES(newStores);
    },

    async bulkDeleteStore(payload) {
      const mutationInput = { ids: payload };
      const addRes = await graphql(
        graphqlOperation(bulkDeleteStoreMutation, {
          input: mutationInput,
        }),
      );
      return addRes;
    },

    async updateStore(payload, rootState) {
      const merchantAccountId = rootState.auth?.user?.merchantAccount?.id;
      const mutationInput = {
        ...payload.values,
        storeStatus: 'NEW',

        merchantAccountId,
      };
      await graphql(
        graphqlOperation(updateStoreMutation, {
          input: mutationInput,
        }),
      );

      const newStores = rootState.stores.stores.map((storeItem) => {
        if (storeItem.id === mutationInput.id) {
          return mutationInput;
        }
        return storeItem;
      });
      dispatch.stores.SET_STORES(newStores);
    },

    addStore(payload, state) {
      const newStores = [...state.stores.stores, payload];
      dispatch.stores.SET_STORES(newStores);
    },
  }),
};

export default storesStore;
